import { BankTransferVariantStyles } from "../bankTransfer.variantTypes";
import { colors } from "../../../../../../../ui/colors";

export const paymnentStyles: BankTransferVariantStyles = {
    expandable: true,
    transition: "all 0.2s ease",
    root: {
        padding: 16,
        borderRadius: 16,
        borderColor: "transparent",
        backgroundColor: "var(--fx-surface-base, #FFFFFF)",
        hover: {
            boxShadow: null,
            transform: null,
            borderColor: "transparent",
        },
    },
    icon: { size: 40, bg: "#ffffff", color: "#0e9925" },
    title: { fontSize: "0.95rem", color: "var(--fx-surface-text, #0F172A)" },
    description: { fontSize: "0.8rem", color: "var(--fx-surface-texttertiary, #94A3B8)", lineHeight: 1.5, marginBottom: 16 },
}